import { Routes, Route } from 'react-router-dom';
import { Scheduling } from './pages/Scheduling';
import { Header } from './components/Header';
import './styles/tailwind.css'
import { GlobalStyle } from './styles/global';
import { ScheduleProvider } from '../src/context/ScheduleContext'
function App() {
  return (
    <ScheduleProvider>
        <main className='flex flex-col min-h-screen w-full max-w-full bg-gray-50'>
          <GlobalStyle />
          <Header />
          <Routes>
            <Route path="/*" element={<Scheduling />} />
          </Routes>
        </main>
    </ScheduleProvider>
  );
}

export default App;
